/** Matter file IDs to attach on the next send (selected + pending from case-page navigation). */
export function mergeMatterDocumentIdsForSend(
  selectedFileIds: string[] | undefined,
  pendingMatterDocumentIds: string[],
): string[] {
  return [...new Set([...(selectedFileIds ?? []), ...pendingMatterDocumentIds])];
}

/** Trims, drops empties, and dedupes when staging matter files from navigation state. */
export function normalizePendingMatterDocumentIds(documentIds: string[]): string[] {
  const trimmed = documentIds.map((id) => id.trim()).filter(Boolean);
  return [...new Set(trimmed)];
}
